import { FormValidationsService } from './form-validations.service';

export default angular
  .module('sfMobile.services.form-validations', [])
  .factory('formValidationsService', FormValidationsService).name;
